import useIsMobile from "../hooks/useIsMobile";

import "./ForthPage.css";
import VideoPlayer from "../Components/VideoPlayer/index";

// import SplitText from "../Components/SplitText/SplitText";
import AnimatedContent from "./animatedContent/AnimatedContent";
const data = "https://brevis-media-res.s3.us-west-1.amazonaws.com/website/mp4/data3.mp4";

export const openTalk = () => {
  window.open("https://form.typeform.com/to/lduiliob", "_blank");
};

function ForthPage() {
  const { isMobile } = useIsMobile();

  return (
    <div className="forthPage" id="forthPage">
      <div>
        {/* <SplitText
          text="{Opening} the Black Box"
          className="pageTitle"
          delay={100}
          duration={0.6}
          ease="power3.out"
          splitType="chars"
          from={{ opacity: 0, y: 40 }}
          to={{ opacity: 1, y: 0 }}
          threshold={0.1}
          rootMargin="-100px"
          textAlign="center"
          onLetterAnimationComplete={() => {}}
        /> */}
        <AnimatedContent
          type="bottom"
          id={"Opening"}
          key={"Opening"}
          duration={800}
        >
          <div className="pageTitle" key="Opening2">
            <span className="black_box">{"{Opening}"}</span> the Black Box
          </div>
        </AnimatedContent>
        {/* <span className="black_box">{"{Opening}"}</span> the Black Box */}
      </div>
      <div className="title2">What if you didn't have to choose?</div>
      {isMobile ? (
        <div className="des">
          <div className="des">
            Brevis allows you to run any computation off-chain with unlimited complexity, then prove it happened correctly with a tiny proof anyone can verify in milliseconds.
          </div>
          <div className="des" style={{ marginTop: 26 }}>
            Advanced applications become both powerful and transparent. The impossible choice disappears.
          </div>
          
        </div>
      ) : (
        <div>
          <div className="des">
            Brevis allows you to run any computation off-chain with unlimited
          </div>
          <div className="des">
            complexity, then prove it happened correctly with a tiny proof
          </div>
          <div className="des">
            anyone can verify in milliseconds.
          </div>
          
          <div className="des" style={{ marginTop: 26 }}>
            Advanced applications become both powerful and transparent. The
          </div>
          <div className="des">
            impossible choice disappears.
          </div>
        </div>
      )}

      <div
        style={{
          // marginTop: 20,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div style={{ width: 600 }}>
          <VideoPlayer src={data} />
        </div>
      </div>
    </div>
  );
}

export default ForthPage;
